import { Modal, Header, Button, Input, Form, Message } from 'semantic-ui-react';

function AddKey({ open, api_key, handleClose, handleAddKey, saving, updateKeyName }) {
	return (
		<Modal
			size="small"
			closeIcon
			open={open}
			onClose={handleClose}
		>
			<Header content="Create a new API key" />

			<Modal.Content>
				{api_key && (
					<>
						<Message info>
							Your api key has been generated. Make sure you copy your new key. You will not be able to view this key again.
						</Message>

						<Message warning>
							{api_key}
						</Message>
					</>
				)}

				{!api_key &&
					<Form>
						<Form.Field>
							<label>Name</label>
							<Input fluid focus placeholder="Name" name="name" onChange={(e) => updateKeyName(e)} />
						</Form.Field>
					</Form>
				}
			</Modal.Content>

			<Modal.Actions>
				<Button color="red" onClick={handleClose}>Close</Button>
				{!api_key &&
					<Button color="green" loading={saving} onClick={handleAddKey}>Add</Button>
				}
			</Modal.Actions>
		</Modal>
	);
}

export default AddKey;
